import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-27 10:53:46
 * @LastEditTime: 2021-11-08 18:55:22
 * @LastEditors: wangshengqiang
 * @Description: 产品或者责任的投保不投保选择
 */
import React, { useEffect } from 'react';
import { dispatch, getState } from '@/store';
import { useClauseRules } from './useRules';
import RowRadioList from '../RowRadioList';
import './index.less';
export default function RadioIsInsured(props) {
  const {
    attrs,
    label,
    formKey
  } = props;
  const handleChange = useClauseRules(attrs.rules, attrs.liability);
  const {
    product
  } = attrs;
  const isAddition = product.productType === 'addition';
  const title = /*#__PURE__*/React.createElement("div", {
    className: "choose-insured-title"
  }, isAddition ? /*#__PURE__*/React.createElement("span", {
    className: "addition"
  }, " \u9644 ") : null, " ", label, ' ');
  useEffect(() => {
    if (attrs.isHolderExemptionInsurance) {
      const holderExemptionList = getState('holderExemptionList') || [];
      holderExemptionList.push(formKey);
      dispatch({
        holderExemptionList
      });
    }
  }, []);
  return /*#__PURE__*/React.createElement(RowRadioList, _extends({}, props, {
    isRequired: true,
    onChange: handleChange,
    label: title
  }));
}